<template>
    <div class="disclose-box">
        <div class="box-head">
            <el-input placeholder="请输入内容" v-model="proName"></el-input>
            <el-button type="primary" @click="doFilter" style="margin-left:1vw;">查询</el-button>
        </div>
        <div class="box-table">
            <el-table
                :data="tableData"
                style="width: 100%"
                height="100%"
                :row-class-name="tableRowClassName"
            >
                <el-table-column prop="index" label="序号" width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.index}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="项目名称" >
                     <template slot-scope="scope">
                        <span>{{scope.row.projectName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="联系人">
                    <template slot-scope="scope">
                        <span>{{scope.row.projectName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="总包单位">
                    <template slot-scope="scope">
                        <span>{{scope.row.projectName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="关键岗位">
                    <template slot-scope="scope">
                        <span>{{scope.row.projectName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="工程信息">
                    <template slot-scope="scope">
                        <span>{{scope.row.projectName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="智慧工地">
                    <template >
                        <el-button type="primary" >设备清单</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="中标时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.projectName||'--'}}</span>
                        <i class="el-icon-edit" @click="editFun(scope.row)" style="margin-left: 1vw;cursor: pointer;color:#409EFF;"></i>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="address" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button type="success" @click="editFun(scope.row)">编辑</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
            ></el-pagination>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="addFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
            :model="addForm"
            ref="addForm"
            label-width="100px"
            :label-position="labelPosition"
            >
                <el-form-item label="中标时间：">
                    <el-date-picker v-model="addForm.time" type="date" value-format="yyyy-MM" placeholder="选择日期"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import util from '../../../untils/util';
export default {
    data(){
        return{
            proName:'',
            tableData:[{}],
            addForm:{
                time:util.myTime.getCurTime(),
            },
            labelPosition:'right',
            dialogTitle:'',
            addFormVisible:false,
            groupId:'',
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
    },
    methods:{
        //查询
        doFilter(){

        },
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        getData(){

        },

        tableRowClassName({row, rowIndex}) {
            if (rowIndex % 2 == 1) {
                return 'warning-row';
            }
            return '';
        },

        //编辑
        editFun(row){
            this.addFormVisible = true
            this.dialogTitle = row.proName
            this.addForm.time = row.time
        },
        //提交
        sumbitAddRow(){
            this.addFormVisible = false
        },

    }
}
</script>

<style scoped>
    .disclose-box{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
    }
    .box-head{
        width: 100%;
        height: 5vh;
        position: relative;
        padding: 0 1vw;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: flex-start;
    }
    .box-table{
        width: 100%;
        height: calc( 100% - 5vh );
        position: relative;
    }
</style>

<style>
    .el-table .warning-row {
        background: #F2F2F7;
    }

    /* .el-table .success-row {
        background: #f0f9eb;
    } */
</style>